import alasql from "alasql";
import axios from "axios";
export default class ProductDatabaseService {
    static loadDatabase = async() => {
        console.log('process.env.REACT_APP_S3_BUCKET+process.env.REACT_APP_PRODUCT_DATABASE_JSON_URL',process.env.REACT_APP_S3_BUCKET+process.env.REACT_APP_PRODUCT_DATABASE_JSON_URL);
        let response  = await axios.get(process.env.REACT_APP_S3_BUCKET+process.env.REACT_APP_PRODUCT_DATABASE_JSON_URL)
        console.log('respose ==>',response);
        if(response.status === 200)
        {
            return response.data
        }
    }
    static getSingleProductByProductSlug = async (productSlug) => {
        let response = await this.loadDatabase()
        const flattenedData = this.getFlatCollectionDatabase(response);
        const query = `SELECT * FROM ? WHERE LOWER(slug) LIKE LOWER('%' + ? + '%')`;
        let matchProduct = alasql(query, [flattenedData, productSlug]);
        return matchProduct[0]
        
    };
    static getProductsByCollectionSlug = async(collectionSlug) => {
        let response = await this.loadDatabase()
        const query = `SELECT * FROM ? WHERE LOWER(collectionSlug) LIKE LOWER('%' + ? + '%')`;
        console.log(alasql(query, [response, collectionSlug]));
        return alasql(query, [response, collectionSlug])[0].products
    
    };

    static searchAll = async (searchKey) => {
        let response = await this.loadDatabase()
        if (searchKey.length > 2 && response.length > 0) {
            const flattenedData = this.getFlatCollectionDatabase(response);
            const sql = `SELECT * FROM ? WHERE LOWER(name) LIKE '%${searchKey.toLowerCase()}%'OR LOWER(collectionName) LIKE '%${searchKey.toLowerCase()}%'`;
            return alasql(sql, [flattenedData]) || [];
        }
        return [];
    }
    static getFlatCollectionDatabase = (collectionDatabase) => {
        const flattenedData = collectionDatabase.flatMap(collection =>
            collection.products.map(product => ({
                ...product,
                collectionName: collection.collectionName,
                collectionSlug: collection.collectionSlug,
                bannerImage: collection.bannerImage,
            }))
        );
        return flattenedData;
    }
}
